"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var DropZone_1 = __importDefault(require("../DropZone"));
var UploadedDocument_1 = __importDefault(require("../UploadedDocument"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var VerificationCard = function (_a) {
    var _b;
    var type = _a.type, icon = _a.icon;
    var t = (0, next_intl_1.useTranslations)('translation');
    var uploadDocument = (0, swr_hooks_1.useUploadDocument)().uploadDocument;
    var docs = (0, swr_hooks_1.useMyDocuments)({ type: type }).data;
    var removeDocument = (0, swr_hooks_1.useRemoveDocument)().removeDocument;
    var onFileDrop = (0, react_1.useCallback)(function (files) {
        uploadDocument({ file: files[0], type: type });
    }, [uploadDocument, type]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("img", { src: icon, className: styles_module_scss_1.default.icon, alt: type }),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.texts },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, t(type)),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, t("".concat(type, "_description"))))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.dropzone },
            react_1.default.createElement(DropZone_1.default, { onFileDrop: onFileDrop }),
            (docs === null || docs === void 0 ? void 0 : docs.document.get.document) &&
                (docs === null || docs === void 0 ? void 0 : docs.document.get.document.length) > 0 && (react_1.default.createElement("div", { className: styles_module_scss_1.default.uploaded },
                t('uploadedFiles'),
                ":")), (_b = docs === null || docs === void 0 ? void 0 : docs.document.get.document) === null || _b === void 0 ? void 0 :
            _b.map(function (document, idx) { return (react_1.default.createElement(UploadedDocument_1.default, { key: "uploadedDocument".concat(idx).concat(type), documentId: document.id, documentTitle: document.name, deleteDocument: removeDocument, status: document.status })); }))));
};
exports.default = VerificationCard;
